t = require('views/internal/teacup-with-helpers')('formatting_help')

module.exports = ->
  t.p ->
    t.format 'trello-uses-markdown-for-formatting-here-are-the-basics-see-the-complete-syntax'

  t.hr()

  t.p '.quiet', ->
    t.format 'first-level-header'
  t.code ->
    t.format 'making-scrambled-eggs-a-primer'
    t.br()
    t.text "\n    ===============================\n  "

  t.hr()

  t.p '.quiet', ->
    t.format 'second-level-header'
  t.code ->
    t.format '1-1-preparation'
    t.br()
    t.text "\n    ----------------\n  "

  t.hr()

  t.p '.quiet', ->
    t.format 'paragraphs'
  t.code ->
    t.format 'add-two-new-lines-to-start-a-new-paragraph-crack-two-eggs-into-the-bowl-and-whisk'

  t.hr()

  t.p '.quiet', ->
    t.format 'bold'
  t.code ->
    t.format 'carefully-crack-the-eggs'

  t.hr()

  t.p '.quiet', ->
    t.format 'emphasis'
  t.code ->
    t.format 'whisk-the-eggs-vigorously'

  t.hr()

  t.p '.quiet', ->
    t.format 'lists'
  t.code ->
    t.format 'ingredients'
    t.br()
    t.br()
    t.format 'eggs'
    t.br()
    t.format 'oil'
    t.br()
    t.format 'optional-milk'

  t.hr()

  t.p '.quiet', ->
    t.format 'links'
  t.code ->
    t.format 'to-download-a-pdf-version-of-the-recipe-click-here-https-example-com-scrambled-eggs-pdf'

  t.hr()

  t.p '.quiet', ->
    t.format 'images'
  t.code ->
    t.format 'the-finished-dish-https-example-com-eggs-png'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/formatting_help.coffee